

import React from 'react';
import ServiceForm from '../components/ServiceForm';



const socialLoginEndpoint = "social-login";

const socialLoginArguments = [
  { name: 'provider', type: 'string',  mandatory: true, default: '', description: 'Only "google" is supported for now'},
  { name: 'idToken', type: 'string',  mandatory: true, default: '', description: 'ID token from the social provider'},
]


export function SocialLogin() {
  return <SocialLoginComponent/>;
}


class SocialLoginComponent extends React.Component {

  render() {

        const socialLoginSample = {
          provider: 'google',
          idToken: 'token data here'
        };
        return (
            <div>
                  <h3>Social Login</h3>

                  <p>Endpoint: <b>{socialLoginEndpoint}</b></p>

                  <p>
                    This service can be used to get the JWT token to be used to access the private services using social login.<br />
                    When the authentication has been completed, the token provided in the JWT object needs to be
                    passed in the request header (Authorization: Bearer &lt;token&gt;).
                  </p>

                  <ServiceForm
                        args={socialLoginArguments}
                        sample={socialLoginSample}
                        endpoint={socialLoginEndpoint}
                        authRequired={false}
                        usePayload={true}
                        isLogin={true}
                  />

                  <h4>Request</h4>
                  <p>
                    A JSON with provider and idToken
                  </p>

                  <h4>Response</h4>
                  <p>
                    A JSON with the JWT object or an autorization denied.
                  </p>

            </div>
        );
  }

} 

